module.exports = __webpack_public_path__ + "img/index-right.0e390165.png";